import React from 'react';
import './LandingPage.css';

export default function AddCategory() {
  return (
    <main className="container" style={{ padding: 24 }}>
      <h1>Add Category</h1>
      <p>Form/page to add a category (placeholder).</p>
    </main>
  );
}
